import { render, staticRenderFns } from "./PhoneOtpBlock.vue?vue&type=template&id=7d73267e&"
import script from "./PhoneOtpBlock.vue?vue&type=script&lang=js&"
export * from "./PhoneOtpBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports